import es from './es';
import en from './en';
import de from './de';
import pt from './pt';

export const SUPPORTED = [
  { code: 'es', locale: 'es-MX', native: 'Español' },
  { code: 'en', locale: 'en-US', native: 'English' },
  { code: 'de', locale: 'de-DE', native: 'Deutsch' },
  { code: 'pt', locale: 'pt-BR', native: 'Português' },
];

const DICTS = { es, en, de, pt };

export const LANG_STORAGE_KEY = 'cav_ui_lang';

export function langFromLocale(locale) {
  if (!locale) return 'es';
  const c = String(locale).toLowerCase().split('-')[0];
  return DICTS[c] ? c : 'es';
}

export function localeFromLang(lang) {
  const row = SUPPORTED.find(s => s.code === lang);
  return row ? row.locale : 'es-MX';
}

export function translate(lang, key, vars) {
  const dict = DICTS[lang] || es;
  let s = dict[key] ?? es[key] ?? key;
  if (vars) {
    Object.entries(vars).forEach(([k, v]) => {
      s = s.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
    });
  }
  return s;
}

export function detectBrowserLang() {
  try {
    const nav = (navigator.languages && navigator.languages[0]) || navigator.language || 'es';
    return langFromLocale(nav);
  } catch {
    return 'es';
  }
}
